import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from '../contexts/Language';

export const Card = (props) => (
            <div className="row">
                <div className="col-12">
                    <div className={"card " + (props.className || "")}>
                        <div className="card-body">
                            {props.Title && <h4 className="mt-0 header-title">{Translate(props.Title)}</h4>}
                            {props.Description && <p className="text-muted m-b-30">{Translate(props.Description)}</p>}
                            <div className="card-tool">
                                {props.Tools}
                            </div>
                            {props.children}
                            {props.Logo && <img src={"/assets/psp-logo/" + props.Logo} alt="" height="30" className="card-logo" />}
                        </div>
                    </div>
                </div>
            </div>
)

Card.prototype = {
    Title: PropTypes.string,
    Description: PropTypes.string
}

